import { createSlice } from '@reduxjs/toolkit';

export interface KnownSkill { id: number; level: number }

/** Level-up events contain an array of IDs, including an empty array on server 1. */
function normalizeKnownSkills(values: any[]): KnownSkill[] {
  const known = new Map<number, KnownSkill>();
  for (const value of values) {
    const skill = typeof value === 'number' ? { id: value, level: 1 } : value;
    if (!skill || !Number.isInteger(skill.id) || skill.id <= 0) continue;
    known.set(skill.id, { id: skill.id, level: skill.level ?? 1 });
  }
  return Array.from(known.values());
}

interface State {
  show: boolean;
  equipped: any[];
  known: KnownSkill[];
}

const initialState: State = {
  show: false,
  equipped: [],
  known: [],
};

export const skillsSlice = createSlice({
  name: 'skills',
  initialState,
  reducers: {
    addKnownSkills: (state, action) => {
      const received = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.known = normalizeKnownSkills([...state.known, ...received]);
    },
    showSkills: (state, action) => {
      state.show = action.payload;
    },
    setEquippedSkills: (state, action) => {
      state.equipped = [...action.payload];

      while (state.equipped.length < 10) {
        state.equipped.push(null);
      }
    },
    setKnownSkills: (state, action) => {
      state.known = normalizeKnownSkills(action.payload ?? []);
    },
  },
});

export const { addKnownSkills, showSkills, setEquippedSkills, setKnownSkills } = skillsSlice.actions;

export default skillsSlice.reducer;
